var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('h1',{staticClass:"font-weight-light mb-0"},[_vm._v("Page "+_vm._s(_vm.$route.path)+"...")]),_c('span',{staticClass:"overline"},[_vm._v("Add other dashboard views")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }